import { fetcher } from "helpers/fetcher";

import {
  TGetStaffMatchingFilterDataReq,
  TGetStaffMatchingFilterDataRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffMatchingFilterData = async (
  params?: TGetStaffMatchingFilterDataReq
) => {
  return await fetcher<
    TGetStaffMatchingFilterDataRes,
    TGetStaffMatchingFilterDataReq["data"]
  >(ENDPOINT.BU.GET_STAFF_MATCHING_FILTER, {
    data: params?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.BU.GET_STAFF_MATCHING_FILTER.version,
      [API_HEADER.BU_ID]: params?.idBu,
    },
  });
};

export const queryGetStaffMatchingFilterData = async (
  params?: TGetStaffMatchingFilterDataReq
) => {
  return (await getStaffMatchingFilterData(params)).data;
};

queryGetStaffMatchingFilterData._key = (
  params?: TGetStaffMatchingFilterDataReq,
  key?: string
) => [ENDPOINT.BU.GET_STAFF_MATCHING_FILTER.url, params, key];
